// import { useEffect, useState, useRef } from 'react'
// import MainFilterSearchBox from './MainFilterSearchBox'
// import BookRideBar from './BookRideBar'
// import { useSelector, useDispatch } from 'react-redux'
// import { dispatch } from '../../../redux/store'
// import { getServiceBannersList } from '../../../redux/slices/common'
// // import { fetchCoreConfig } from "../../../redux/slices/user";
// import { Swiper, SwiperSlide } from 'swiper/react'
// import { useRouter } from 'next/router'
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import { Navigation, Scrollbar, Autoplay, Controller } from 'swiper'
// import { Box, Paper, Typography } from '@mui/material'

// const HeroRSL = ({ hourly }) => {
//   const router = useRouter()
//   const videoRef = useRef(null)
//   const [data, setData] = useState([])
//   const [bannerLocalImage, setBannerLocalImage] = useState(
//     JSON.parse(localStorage.getItem('bannerImageVideo')) || {}
//   )
//   const { serviceBannerVideoList } = useSelector(state => state.common)
//   const [currentTab, setCurrentTab] = useState('Cab')
//   const [bannerData, setBannerData] = useState(null)
//   const [backgroundImages, setBackgroundImages] = useState(null)
//   const [isVideo, setIsVideo] = useState(false)
//   const [backgroundImagesTitle, setBackgroundImagesTitle] = useState(null)

//   useEffect(() => {
//     if (router.query.tab) {
//       setCurrentTab(router.query.tab)
//     }
//   }, [router.query])

//   useEffect(() => {
//     // dispatch(fetchCoreConfig());
//     dispatch(getServiceBannersList())
//   }, [])

//   useEffect(() => {
//     if (serviceBannerVideoList?.length > 0) {
//       const filteredBanners = serviceBannerVideoList?.filter(
//         item => item.name === 'Cab'
//       )
//       if (filteredBanners?.length > 0) {
//         // Transform data for easier access
//         setBackgroundImagesTitle(filteredBanners[0].title);
//         const transformedData = filteredBanners.reduce((acc, banner) => {
//           acc[banner.name] = banner.src || [] // Ensure it's always an array
//           return acc
//         }, {})

//         // Store in local storage
//         localStorage.setItem(
//           'bannerImageVideo',
//           JSON.stringify(transformedData)
//         )

//         // Update state with transformed data
//         setData(transformedData)
//         // setLoader(false)
//       }
//     }
//   }, [serviceBannerVideoList, currentTab])

//   useEffect(() => {
//     if (data) {
//       const storedBannerImage = localStorage.getItem('bannerImageVideo')

//       if (storedBannerImage) {
//         const bannerImageList = JSON.parse(storedBannerImage)
//         setBannerLocalImage(prevState =>
//           JSON.stringify(prevState) !== JSON.stringify(bannerImageList)
//             ? bannerImageList
//             : prevState
//         )
//       }
//     }
//   }, [data])

//   useEffect(() => {
//     if (currentTab && bannerLocalImage) {
//       setBackgroundImages(bannerLocalImage[currentTab] ?? null)
//     }
//   }, [currentTab, bannerLocalImage])

//   const handleBookingRide = () => {
//     if (bannerData?.link && bannerData.link !== '') {
//       window.open(bannerData.link, '_blank') // Opens link in a new tab
//     }
//   }

//   useEffect(() => {
//     if (
//       backgroundImages !== undefined &&
//       backgroundImages !== null &&
//       backgroundImages !== ''
//     ) {
//       // Check if the file is a video
//       const videoFormats = ['.mp4', '.webm', '.ogg']
//       const isVideoFile = videoFormats.some(format =>
//         backgroundImages?.toLowerCase().endsWith(format)
//       )
//       setIsVideo(isVideoFile)
//     }
//   }, [backgroundImages])

//   useEffect(() => {
//     if (isVideo && videoRef.current) {
//       videoRef.current.play().catch(error => {
//         console.error('Autoplay failed:', error)
//       })
//     }
//   }, [isVideo, backgroundImages])

//   return (
//     <section className='masthead_rsl -type-3 z-5'>
//       <div className='masthead_rsl__bg'>
//         {backgroundImages ? (
//           <Swiper
//             spaceBetween={20}
//             className='overflow-visible'
//             scrollbar={{ draggable: true }}
//             style={{ height: '100%' }}
//             autoplay={{ delay: 2500, disableOnInteraction: false }}
//             pagination={{ clickable: true }}
//             modules={[Controller, Autoplay, Scrollbar, Navigation]}
//             navigation={{
//               nextEl: '.js-second-destination-next',
//               prevEl: '.js-second-destination-prev'
//             }}
//           >
//             <SwiperSlide key={backgroundImages}>
//               <div style={{ position: "relative", width: "100%", height: "100%" }}>
//                 {isVideo ? (
//                   <video
//                     ref={videoRef}
//                     autoPlay
//                     loop
//                     muted
//                     playsInline
//                     className='video-background'
//                     key={backgroundImages}
//                   >
//                     <source
//                       src={`${process.env.IMAGE_BASE_URL}/${backgroundImages}`}
//                       type='video/mp4'
//                     />
//                     Your browser does not support the video tag.
//                   </video>
//                 ) : (
//                   <video
//                     autoPlay
//                     loop
//                     muted
//                     playsInline
//                     className='video-background'
//                   >
//                     <source
//                       src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1757919861588.mp4`}
//                       type='video/mp4'
//                     />
//                     Your browser does not support the video tag.
//                   </video>
//                   // <img
//                   //   alt='banner'
//                   //   // src={`${process.env.IMAGE_BASE_URL}/${backgroundImages}`}
//                   //   src={`/img/banner/banner.svg`}
//                   //   className='js-lazy'
//                   //   style={{
//                   //     width: '100vw',
//                   //     height: '100%',
//                   //     objectFit: 'cover',
//                   //     objectPosition: 'top'
//                   //   }}
//                   // />
//                 )}
//                 {/* Gradient overlay */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     bottom: 0,
//                     left: 0,
//                     right: 0,
//                     top: 0,
//                     background: "linear-gradient(to top, #000000 0%, rgba(0, 0, 0, 0) 60%)",
//                     zIndex: 1,
//                     pointerEvents: "none",
//                   }}
//                 />
//                 {/* Bottom overlay */}
//                 <div className='container for-mobile for-filter rsl__Wrapper' style={{ zIndex: 2 }}>
//                   <div className='row justify-center'>
//                     <div className='col-auto'>
//                       <div className='masthead_rsl__tabs rsl-tab_md'>
//                         <Box
//                           sx={{
//                             position: "absolute",
//                             left: { xs: -10, sm: "8%", md: "1%" },
//                             right: { xs: 2, sm: "clamp(16px,4vw,64px)" },
//                             bottom: "clamp(24px, 18vh, 130px)",   // default
//                             zIndex: 2,
//                             pointerEvents: "none",
//                             width: { xs: "auto", md: 1100 },

//                             // tablet-only override (768–899.95px)
//                             "@media (min-width:768px) and (max-width:899.95px)": {
//                               top: -500,
//                               bottom: "auto",                    // IMPORTANT: cancel bottom so top takes effect
//                               // transform: "translate(-50%, 0)", // add only if you need a vertical translate
//                             },
//                           }}
//                         >
//                           <Typography
//                             component="h1"
//                             className='jura'
//                             sx={{
//                               m: 0,
//                               textAlign: "start",
//                               color: "#fff",
//                               lineHeight: { xs: 1.25, md: 1.1 },
//                               fontWeight: { xs: 400, md: 600 },
//                               fontSize: { xs: 22, sm: 26, md: 40 },
//                               px: { xs: 2, md: 0 },
//                               position: "relative"
//                             }}
//                           >
//                             Your Ride, Your Way <br />
//                             <span style={{
//                               position: "relative", display: "inline-block",
//                             }}>
//                               Book Now
//                               <img
//                                 src="/img/app/booknow-outline.svg" // export your oval from Figma
//                                 alt="highlight"
//                                 style={{
//                                   position: "absolute",
//                                   width: "211.66px",     // from Figma
//                                   height: "auto",     // from Figma
//                                   top: "-6px",          // adjust to wrap text
//                                   left: "-5px",         // adjust horizontal centering
//                                   transform: "rotate(-3.86deg)", // keep Figma tilt
//                                   opacity: 1,
//                                   zIndex: -1,            // behind text
//                                   pointerEvents: "none",
//                                 }}
//                               />
//                             </span>{" "}
//                             And Hit The Road On Comfort
//                           </Typography>

//                         </Box>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           </Swiper>
//         ) : (
//           <div className='flex items-center justify-center h-[600px] bg-gray-200 text-gray-500'></div>
//         )}
//       </div>
//       {
//         bannerData?.linkTitle && (
//           <div className='container text-white position-absolute top-35 start-0 translate-middle-y px-3 px-md-5 py-4 py-md-5'>
//             <div className='col-lg-6 col-md-8'>
//               <h1 className='fw-semibold fs-3 fs-md-4 fs-lg-5'>
//                 {bannerData?.linkTitle}
//               </h1>
//               {bannerData?.linkDescription && (
//                 <p className='fs-6 fs-md-5'>{bannerData?.linkDescription}</p>
//               )}
//               {bannerData?.link && (
//                 <button
//                   className='mainSearch__submit btn-1 button bg-dark-3 text-white py-3 px-28 rounded-md shadow-md hover:bg-dark-4 transition w-[200px] btn-join-img mt-2'
//                   onClick={handleBookingRide}
//                 >
//                   Book Now <span className='ms-2'>→</span>
//                 </button>
//               )}
//             </div>
//           </div>
//         )
//       }

//       <div className='container for-mobile for-filter rsl__Wrapper'>
//         <div className='row justify-center'>
//           <div className='col-auto'>
//             <div className='masthead_rsl__tabs rsl-tab_md'>
//               <BookRideBar hourly={hourly} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section >
//   )
// }

// export default HeroRSL

import { useEffect, useState, useRef } from 'react'
import MainFilterSearchBox from './MainFilterSearchBox'
import BookRideBar from './BookRideBar'
import { useSelector, useDispatch } from 'react-redux'
import { dispatch } from '../../../redux/store'
import { getServiceBannersList } from '../../../redux/slices/common'
// import { fetchCoreConfig } from "../../../redux/slices/user";
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRouter } from 'next/router'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Scrollbar, Autoplay, Controller } from 'swiper'
import { Box, Paper, Typography } from '@mui/material'

const HeroRSL = ({ hourly }) => {
  const router = useRouter()
  const videoRef = useRef(null)
  const [data, setData] = useState([])
  const [bannerLocalImage, setBannerLocalImage] = useState(
    JSON.parse(localStorage.getItem('bannerImageVideo')) || {}
  )
  const { serviceBannerVideoList } = useSelector(state => state.common)
  const [currentTab, setCurrentTab] = useState('Cab')
  const [bannerData, setBannerData] = useState(null)
  const [backgroundImages, setBackgroundImages] = useState(null)
  const [isVideo, setIsVideo] = useState(false)
  const [backgroundImagesTitle, setBackgroundImagesTitle] = useState(null)

  useEffect(() => {
    if (router.query.tab) {
      setCurrentTab(router.query.tab)
    }
  }, [router.query])

  useEffect(() => {
    // dispatch(fetchCoreConfig());
    dispatch(getServiceBannersList())
  }, [])

  useEffect(() => {
    if (serviceBannerVideoList?.length > 0) {
      const filteredBanners = serviceBannerVideoList?.filter(
        item => item.name === 'Cab'
      )
      if (filteredBanners?.length > 0) {
        // Transform data for easier access
        setBackgroundImagesTitle(filteredBanners[0].title);
        const transformedData = filteredBanners.reduce((acc, banner) => {
          acc[banner.name] = banner.src || [] // Ensure it's always an array
          return acc
        }, {})

        // Store in local storage
        localStorage.setItem(
          'bannerImageVideo',
          JSON.stringify(transformedData)
        )

        // Update state with transformed data
        setData(transformedData)
        // setLoader(false)
      }
    }
  }, [serviceBannerVideoList, currentTab])

  useEffect(() => {
    if (data) {
      const storedBannerImage = localStorage.getItem('bannerImageVideo')

      if (storedBannerImage) {
        const bannerImageList = JSON.parse(storedBannerImage)
        setBannerLocalImage(prevState =>
          JSON.stringify(prevState) !== JSON.stringify(bannerImageList)
            ? bannerImageList
            : prevState
        )
      }
    }
  }, [data])

  useEffect(() => {
    if (currentTab && bannerLocalImage) {
      setBackgroundImages(bannerLocalImage[currentTab] ?? null)
    }
  }, [currentTab, bannerLocalImage])

  const handleBookingRide = () => {
    if (bannerData?.link && bannerData.link !== '') {
      window.open(bannerData.link, '_blank') // Opens link in a new tab
    }
  }

  useEffect(() => {
    if (
      backgroundImages !== undefined &&
      backgroundImages !== null &&
      backgroundImages !== ''
    ) {
      // Check if the file is a video
      const videoFormats = ['.mp4', '.webm', '.ogg']
      const isVideoFile = videoFormats.some(format =>
        backgroundImages?.toLowerCase().endsWith(format)
      )
      setIsVideo(isVideoFile)
    }
  }, [backgroundImages])

  useEffect(() => {
    if (isVideo && videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error('Autoplay failed:', error)
      })
    }
  }, [isVideo, backgroundImages])

  return (
    <section className='masthead_rsl -type-3 z-5'>
      <div className='masthead_rsl__bg'>
        {backgroundImages ? (
          <Swiper
            spaceBetween={20}
            className='overflow-visible'
            scrollbar={{ draggable: true }}
            style={{ height: '100%' }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            modules={[Controller, Autoplay, Scrollbar, Navigation]}
            navigation={{
              nextEl: '.js-second-destination-next',
              prevEl: '.js-second-destination-prev'
            }}
          >
            <SwiperSlide key={backgroundImages}>
              <div style={{ position: "relative", width: "100%", height: "100%" }}>
                {/* {isVideo ? (
                  <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='video-background'
                    key={backgroundImages}
                  >
                    <source
                      src={`${process.env.IMAGE_BASE_URL}/${backgroundImages}`}
                      type='video/mp4'
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : ( */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className='video-background'
                >
                  <source
                    src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1757919861588.mp4`}
                    type='video/mp4'
                  />
                  Your browser does not support the video tag.
                </video>
                {/* )} */}
                {/* Gradient overlay */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                    background: "linear-gradient(to top, rgb(62 62 62) 0%, rgba(0, 0, 0, 0) 35%)",
                    zIndex: 1,
                    pointerEvents: "none",
                  }}
                />
                {/* Bottom overlay */}
                <div className='container for-mobile for-filter rsl__Wrapper' style={{ zIndex: 2 }}>
                  <div className='row justify-center'>
                    <div className='col-auto'>
                      <div className='masthead_rsl__tabs rsl-tab_md'>
                        <Box
                          sx={{
                            position: "absolute",
                            left: { xs: -10, sm: "8%", md: "1%" },
                            right: { xs: 2, sm: "clamp(16px,4vw,64px)" },
                            bottom: "clamp(24px, 18vh, 40px)",   // default
                            zIndex: 2,
                            pointerEvents: "none",
                            width: { xs: "auto", md: 1100 },

                            // tablet-only override (768–899.95px)
                            "@media (min-width:768px) and (max-width:899.95px)": {
                              top: -330,
                              bottom: "auto",                    // IMPORTANT: cancel bottom so top takes effect
                              // transform: "translate(-50%, 0)", // add only if you need a vertical translate
                            },
                          }}
                        >
                          <Typography
                            component="h1"
                            className='jura'
                            sx={{
                              m: 0,
                              textAlign: "center",
                              color: "#fff",
                              lineHeight: { xs: 1.25, md: 1.1 },
                              fontWeight: { xs: 400, md: 600 },
                              fontSize: { xs: 22, sm: 26, md: 40 },
                              px: { xs: 2, md: 0 },
                              position: "relative"
                            }}
                          >
                            Your Ride, Your Way <br />
                            <span style={{
                              position: "relative", display: "inline-block",
                            }}>
                              Book Now
                              <img
                                src="/img/app/booknow-outline.svg" // export your oval from Figma
                                alt="highlight"
                                style={{
                                  position: "absolute",
                                  width: "211.66px",     // from Figma
                                  height: "auto",     // from Figma
                                  top: "-6px",          // adjust to wrap text
                                  left: "-5px",         // adjust horizontal centering
                                  transform: "rotate(-3.86deg)", // keep Figma tilt
                                  opacity: 1,
                                  zIndex: -1,            // behind text
                                  pointerEvents: "none",
                                }}
                              />
                            </span>{" "}
                            And Hit The Road On Comfort
                          </Typography>

                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        ) : (
          <div className='flex items-center justify-center h-[600px] bg-gray-200 text-gray-500'></div>
        )}
      </div>
      {
        bannerData?.linkTitle && (
          <div className='container text-white position-absolute top-35 start-0 translate-middle-y px-3 px-md-5 py-4 py-md-5'>
            <div className='col-lg-6 col-md-8'>
              <h1 className='fw-semibold fs-3 fs-md-4 fs-lg-5'>
                {bannerData?.linkTitle}
              </h1>
              {bannerData?.linkDescription && (
                <p className='fs-6 fs-md-5'>{bannerData?.linkDescription}</p>
              )}
              {bannerData?.link && (
                <button
                  className='mainSearch__submit btn-1 button bg-dark-3 text-white py-3 px-28 rounded-md shadow-md hover:bg-dark-4 transition w-[200px] btn-join-img mt-2'
                  onClick={handleBookingRide}
                >
                  Book Now <span className='ms-2'>→</span>
                </button>
              )}
            </div>
          </div>
        )
      }
      {/* <div className='container for-mobile for-filter rsl__Wrapper'>
        <div className='row justify-center'>
          <div className='col-auto'>
            <div className='masthead_rsl__tabs rsl-tab_md'>
              <BookRideBar hourly={hourly} />
            </div>
          </div>
        </div>
      </div> */}
    </section >
  )
}

export default HeroRSL
